import styles from "../illustration.module.scss";
import { Diamond, Plus, Ring } from "./shapes";

const BACK_BARS = [39.33, 39.33 + 33.005, 39.33 + 66.01, 39.33 + 99.015];

/** `ilu-type-obras` (10259:23828), 197×98: cartão de categoria sobre um cartão de fundo. */
export function TipoObras() {
  return (
    <>
      <rect
        className={styles.strokeSurface100Fill50}
        x="25.66"
        y="40.55"
        width="149.94"
        height="29.71"
        rx="11.2"
        strokeWidth="0.721"
      />
      {BACK_BARS.map((x) => (
        <rect
          key={x}
          className={styles.fillSurface100}
          x={x}
          y="52.87"
          width="24.31"
          height="5.07"
          rx="2.53"
        />
      ))}
      <rect
        className={`${styles.fillSurface0} ${styles.shadowIllustrationSoft}`}
        x="16.41"
        y="17.99"
        width="159.54"
        height="40.7"
        rx="11.56"
      />
      <g transform="translate(27.51 27.24)">
        <rect className={styles.fillSurface50} width="24.05" height="22.2" rx="5.55" />
        <path className={styles.fillPrimary700} d="M12.02 3.7l5.61 4.16H6.42L12.02 3.7Z" />
        <path
          className={styles.fillPrimary700}
          d="M5.55 11.1h12.95v6.47a.93.93 0 0 1-.93.93H6.47a.93.93 0 0 1-.92-.93V11.1Z"
        />
      </g>
      <rect
        className={styles.fillPrimary700}
        x="60.81"
        y="31.42"
        width="104.05"
        height="5.07"
        rx="2.53"
      />
      <rect
        className={styles.fillSurface100}
        x="60.81"
        y="40.18"
        width="37"
        height="5.07"
        rx="2.53"
      />
      <rect
        className={styles.fillSurface100}
        x="101.5"
        y="40.18"
        width="27.75"
        height="5.07"
        rx="2.53"
      />
      <Diamond cx={5.55} cy={19.1} size={7.4} />
      <Diamond cx={172.03} cy={86.62} size={7.4} />
      <Plus cx={188.22} cy={24.51} arm={1.89} width={1.85} />
      <Plus cx={20.81} cy={5.09} arm={1.89} width={1.85} />
      <Ring cx={168.79} cy={6.01} r={2.54} width={1.39} />
      <Ring cx={30.06} cy={90.18} r={2.54} width={1.39} />
    </>
  );
}
